module.exports = __webpack_public_path__ + "img/mountedcrane_parked.3f8ee3d6.svg";